/**
 * Wraps console object and prefixes log messages with {name}
 *
 * @param {string} name Name of the logger
 * @param {boolean} enabled If false no messages will be logged
 * @returns {Console}
 */
export function createLogger(name, enabled = true) {

    const _prefix = `[${name}]`;

    if (import.meta.env.PROD) {
        enabled = false;
    }

    function _log(fn, ...args) {
        if (!enabled) return;

        const [msg, ...rest] = args;
        /// Check if first element in array is string (ie a message)
        const isMsgStr = typeof msg === "string";

        // Only add message to prefix if its string otherwise add nothing
        const msgStr = `${_prefix}${isMsgStr ? " " + msg : ""}`;

        // Call console method with args
        return fn.apply(console, [msgStr].concat(...(isMsgStr ? rest : args)));
    }

    return {
        ...console,
        log: (...args) => _log(console.log, args),
        error: (...args) => _log(console.error, args),
        info: (...args) => _log(console.info, args),
        debug: (...args) => _log(console.debug, args),
        warn: (...args) => _log(console.warn, args),
        time: (label) => {
            if (!enabled) return;
            console.time(`${_prefix} ${label}`);
        },
        timeEnd(label) {
            if (!enabled) return;
            console.timeEnd(`${_prefix} ${label}`);
        }
    };

}
